<template>
  <div class='wrapper'>
    <div class='info-list'>
      <div class='info-item'>
        <span class='info-label'>手机号</span>
        <span class='info-value'>{{ personInfo.telnum || '-' }}</span>
      </div>
      <div class='info-item'>
        <span class='info-label'>昵称</span>
        <span class='info-value'>{{ personInfo.nickName || '-' }}</span>
      </div>
      <div class='info-item'>
        <span class='info-label'>性别</span>
        <span class='info-value'>{{ personInfo.sex || '-' }}</span>
      </div>
      <div class='info-item'>
        <span class='info-label'>出生日期</span>
        <span class='info-value'>{{ personInfo.birthday || '-' }}</span>
      </div>
    </div>
    <div class='copy-btn-wrap'>
      <button class='copy-btn' @click='copyPersonInfo'>复制个人信息</button>
    </div>
  </div>
</template>

<script>
import { getPersonInfo } from '@/api/floor'

export default {
  name: 'PersonInfoCopy',
  data() {
    return {
      personInfo: {}
    }
  },
  created() {
    this.getPersonInfo()
  },
  methods: {
    getPersonInfo() {
      getPersonInfo().then(res => {
        if (res.code === 200) {
          this.personInfo = res.data || {}
        }
      }).catch(() => {
      })
    },
    copyPersonInfo() {
      const text = this.formatPersonInfo()
      this.$copyText(text).then(() => {
        this.$toast.success('复制成功')
      }).catch(() => {
        this.$toast.fail('复制失败，请手动复制')
      })
    },
    formatPersonInfo() {
      return `手机号：${this.personInfo.telnum || '-'}
昵称：${this.personInfo.nickName || '-'}
性别：${this.personInfo.sex || '-'}
出生日期：${this.personInfo.birthday || '-'}`
    }
  }
}
</script>

<style scoped lang='scss'>
.wrapper {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-top: 0.1rem;
}

.info-list {
  background-color: #ffffff;
  margin: 0 0.1rem 0.1rem;
  border-radius: 0.08rem;
  overflow: hidden;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.16rem;
  border-bottom: 0.01rem solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  font-size: 0.15rem;
  color: #333333;
}

.info-value {
  font-size: 0.15rem;
  color: #666666;
}

.copy-btn-wrap {
  padding: 0.2rem 0.1rem;
}

.copy-btn {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  background-color: #ffffff;
  border: 0.01rem solid #3180ff;
  border-radius: 0.25rem;
  color: #3180ff;
  font-size: 0.16rem;
  font-weight: 600;
  outline: none;
  cursor: pointer;
}
</style>
